import { Box, GridLegacy as Grid, TextField } from '@mui/material';
import SubSubtitle from 'components/SubSubtitle';
import { useTranslation } from 'react-i18next';
import { filterNumbers } from 'utils/inputs';

function NonAlphanumericPolicyForm({
  minNonAlphanumeric,
  minNonAlphanumericError,
  maxNonAlphanumeric,
  maxNonAlphanumericError,
  onChange,
}) {
  const { t } = useTranslation();

  return (
    <Box marginBottom="48px">
      <SubSubtitle>{t('organization.organization-settings.password-policy.subsubtitle-non-alphanumeric')}</SubSubtitle>
      <Grid container direction="row" rowSpacing="16px" columnSpacing={1} sx={{ marginTop: '4px' }}>
        <Grid item xs={12} sm={6}>
          <TextField
            id="min-non-alphanumeric"
            value={minNonAlphanumeric}
            onChange={(event) => onChange(filterNumbers(event.target.value), maxNonAlphanumeric)}
            variant="outlined"
            label={t('organization.organization-settings.password-policy.min-label')}
            error={Boolean(minNonAlphanumericError)}
            helperText={minNonAlphanumericError}
            data-testid="min-non-alphanumeric-text-field"
            inputProps={{ 'data-testid': 'min-non-alphanumeric-input' }}
            FormHelperTextProps={{ 'data-testid': 'min-non-alphanumeric-error' }}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            id="max-non-alphanumeric"
            value={maxNonAlphanumeric}
            onChange={(event) => onChange(minNonAlphanumeric, filterNumbers(event.target.value))}
            label={t('organization.organization-settings.password-policy.max-label')}
            variant="outlined"
            error={Boolean(maxNonAlphanumericError)}
            helperText={maxNonAlphanumericError}
            data-testid="max-non-alphanumeric-text-field"
            inputProps={{ 'data-testid': 'max-non-alphanumeric-input' }}
            FormHelperTextProps={{ 'data-testid': 'max-non-alphanumeric-error' }}
            fullWidth
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default NonAlphanumericPolicyForm;
